module.exports = __webpack_public_path__ + "media/images/twitter-6c834ed9da3be96c655a44d8eb0c5fb1.png";